import React, { useMemo } from "react";
import "./DictionaryTabList.scss";
import { CustomTable } from "src/app/components/CustomTable/CustomTable";
import goToImage from "src/images/share-alt.svg";
import { Img } from "src/app/components/Img/Img";
import { openDictionaryDetails } from "src/app/components/DictionaryDetails/methods";
import { useHistory } from "react-router";
import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as PlusIcon } from "src/images/plus-white.svg";
import { ReactComponent as CircleArrowDownIcon } from "src/images/circle-angle-down.svg";
import {
  actionColumnWidth,
  nameColumnWidth,
} from "../../../GlobalActivityTab/utils";

export default function DictionaryTabList(props) {
  const {
    list,
    dictionaryData,
    showAssignDictionaryElementModal,
    isDictionaryListLoading,
    showAddNewDictionaryElementModal,
  } = props;

  const history = useHistory();

  const dictionaryElementName = dictionaryData?.wsDictionaryElementName;

  const rows = useMemo(
    () =>
      list.map((item) => {
        return {
          name: item.title,
          action: <Img src={goToImage} fallbackImageSrc={goToImage} />,
          onRowClick: () =>
            openDictionaryDetails(
              history,
              item.uuid,
              dictionaryData.wsDictionaryUuid,
            ),
        };
      }),
    [list],
  );

  const getColumns = (name) => [
    {
      Header: `${name} NAME`,
      accessor: `name`,
      width: nameColumnWidth,
    },
    {
      Header: "ACTION",
      accessor: "action",
      width: actionColumnWidth,
    },
  ];

  return (
    <div className="dictionary-tab-list">
      <CustomTable
        headerClassName="activity-tab__table-header"
        columns={getColumns(dictionaryElementName)}
        data={rows}
        isLoading={isDictionaryListLoading}
      />
      <div className="dictionary-tab-list__buttons">
        <Button
          variant="blue"
          size="small"
          onClick={showAddNewDictionaryElementModal}
        >
          <PlusIcon />
          <span>
            <IDHFormattedMessage id="ws_add_new" defaultMessage="Add new" />{" "}
            {dictionaryElementName}
          </span>
        </Button>
        <Button
          variant="white-with-light-grey-border"
          size="small"
          onClick={showAssignDictionaryElementModal}
        >
          <CircleArrowDownIcon />
          <span>
            <IDHFormattedMessage
              id="ws_select_existing_vendor"
              defaultMessage="Select existing"
            />{" "}
            {dictionaryElementName}
          </span>
        </Button>
      </div>
    </div>
  );
}
